import React from "react";
import { useTranslation } from "react-i18next";
import "../styles/BlockchainShowcase.css";

/**
 * Présentation volontairement limitée à ce qui existe aujourd'hui.
 * Pas de Smart Contracts / KYC / audit trail blockchain tant que ces fonctions
 * ne sont pas réellement implémentées.
 */
const BlockchainShowcase = () => {
  const { t } = useTranslation();

  const features = [
    {
      id: "fingerprint",
      icon: "⌁",
      title: t("blockchainShowcase.current.fingerprint.title"),
      description: t("blockchainShowcase.current.fingerprint.description"),
      status: t("blockchainShowcase.current.available"),
    },
    {
      id: "timestamp",
      icon: "◷",
      title: t("blockchainShowcase.current.timestamp.title"),
      description: t("blockchainShowcase.current.timestamp.description"),
      status: t("blockchainShowcase.current.available"),
    },
    {
      id: "verify",
      icon: "✓",
      title: t("blockchainShowcase.current.verify.title"),
      description: t("blockchainShowcase.current.verify.description"),
      status: t("blockchainShowcase.current.available"),
    },
    {
      id: "tezos",
      icon: "↗",
      title: t("blockchainShowcase.current.tezos.title"),
      description: t("blockchainShowcase.current.tezos.description"),
      status: t("blockchainShowcase.current.coming"),
    },
  ];

  return (
    <div className="blockchain-showcase">
      <div className="showcase-header">
        <div className="header-content">
          <h1 className="showcase-title">
            {t("blockchainShowcase.current.title")}
          </h1>
          <p className="showcase-subtitle">
            {t("blockchainShowcase.current.subtitle")}
          </p>
        </div>
      </div>

      <div className="features-grid">
        {features.map((feature) => (
          <div key={feature.id} className="feature-card available">
            <div className="feature-icon">{feature.icon}</div>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
            <div className="feature-status">
              <span className="status-badge available">{feature.status}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="blockchain-info">
        <div className="info-card">
          <h3>{t("blockchainShowcase.current.scope.title")}</h3>
          <p>{t("blockchainShowcase.current.scope.text")}</p>
        </div>
        <div className="info-card">
          <h3>{t("blockchainShowcase.current.privacy.title")}</h3>
          <p>{t("blockchainShowcase.current.privacy.text")}</p>
        </div>
      </div>
    </div>
  );
};

export default BlockchainShowcase;
